import { render, staticRenderFns } from "./SWidget.vue?vue&type=template&id=bfcf86f0&scoped=true&"
import script from "./SWidget.vue?vue&type=script&lang=js&"
export * from "./SWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcf86f0",
  null
  
)

export default component.exports